import { Capacitor } from '@capacitor/core';

export const platform = {
  isWeb: !Capacitor.isNativePlatform(),
  isIOS: Capacitor.getPlatform() === 'ios',
  isAndroid: Capacitor.getPlatform() === 'android',
  isNative: Capacitor.isNativePlatform()
};

export function usePlatform() {
  return platform;
}
